import React, { Component } from "react";
import { empty } from "../shared/helpers/generalHelper";
import moment from "moment";
import { MOMENT_READABLE_DATE_FORMAT, MOMENT_READABLE_DATETIME_FORMAT, MOMENT_SQL_DATE_FORMAT } from "../shared/utils/constants";
import { apiCall } from "../shared/helpers/networkHelper";
import { POST_REPORT_INV_STOCK_TRANSACTION } from "../shared/utils/endpoints";
import ErrorHandler from "../shared/classes/ErrorHandler";
import { Button, Col, Empty, Row, Spin, Table, message } from "antd";
import { formatOptionalDecimal } from "../shared/helpers/stringHelper";
import { connect } from "react-redux";
import styles from "./ReportProductConsumptionPrint.module.scss";

class ReportProductConsumptionPrint extends Component {

    constructor(props) {
        super(props);

        const url = new URL(window.location.href);

        this.state = {
            loading: false,
            transactions: null,
            reportDateFrom: url.searchParams.get('start_date'),
            reportDateTo: url.searchParams.get('end_date'),
        };
    }

    componentDidMount() {
        const { reportDateFrom, reportDateTo } = this.state;
        const { posConfig } = this.props;
        const businessOutletId = posConfig && posConfig.business_outlet_id;

        if (empty(businessOutletId)) {
            message.error('Outlet kasir tidak ditemukan');
            return;
        }

        const formData = new URLSearchParams({
            grouping_by: `buo_${businessOutletId}`,
            grouping_by_text: posConfig.outlet_name || '',
            start_date: reportDateFrom,
            end_date: reportDateTo,
            is_stock_in: 1,
            is_sales: 1,
            is_consumption: 1,
            is_ingredient: 1,
            is_bad_stock: 1,
            is_adjustment: 1,
            is_transfer_out: 1,
            is_transfer_in: 1,
            is_completed: 1,
            is_void: 1,
            length: -1,
        });

        this.loaderShow();
        apiCall(
            POST_REPORT_INV_STOCK_TRANSACTION,
            "post",
            formData,
            res => {
                this.setState({
                    transactions: (res.data && res.data.data) ? res.data.data : [],
                });
            },
            err => {
                ErrorHandler.handleGeneralError(err);
            }, () => {
                this.loaderHide();
            }
        );
    }

    loaderShow = () => {
        this.setState({ loading: true });
    };

    loaderHide = () => {
        this.setState({ loading: false });
    };

    formatQty = (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        return formatOptionalDecimal(value);
    };

    formatDatetime = (value) => {
        if (empty(value)) {
            return '';
        }
        const m = moment(value);
        if (!m.isValid()) {
            return value;
        }
        return m.format('DD MMM YYYY HH:mm');
    };

    renderTransactionTable = (transactions) => {
        const columns = [
            { title: "Trx ID", dataIndex: "trx_id", key: "trx_id" },
            { title: "Trx Type", dataIndex: "trx_type", key: "trx_type" },
            {
                title: "Trf / Doc",
                key: "trf_doc",
                render: (row) => [row.trf_id, row.document_no, row.pos_trx_code].filter(v => !empty(v)).join(' / ')
            },
            {
                title: "Date & Time",
                dataIndex: "trx_datetime",
                key: "trx_datetime",
                render: (value) => this.formatDatetime(value)
            },
            { title: "Type", dataIndex: "item_type", key: "item_type" },
            { title: "Category", dataIndex: "category_name", key: "category_name" },
            { title: "SKU", dataIndex: "sku", key: "sku" },
            {
                title: "Item",
                key: "item",
                render: (row) => empty(row.variant_name)
                    ? row.item_name
                    : `${row.item_name} - ${row.variant_name}`
            },
            {
                title: "Good Qty",
                dataIndex: "qty",
                key: "qty",
                render: (value) => this.formatQty(value)
            },
            {
                title: "Bad Qty",
                dataIndex: "drv_bad_qty",
                key: "drv_bad_qty",
                render: (value) => this.formatQty(value)
            },
            { title: "Uom", dataIndex: "unit_name", key: "unit_name" },
            {
                title: "Balance Qty Good Stock",
                dataIndex: "drv_current_qty",
                key: "drv_current_qty",
                render: (value) => this.formatQty(value)
            },
            {
                title: "Balance Qty Bad Stock",
                dataIndex: "drv_current_bad_qty",
                key: "drv_current_bad_qty",
                render: (value) => this.formatQty(value)
            },
            {
                title: "Notes",
                key: "notes",
                render: (row) => row.notes || row.reason || ''
            },
            { title: "Cashier Email", dataIndex: "business_user_email", key: "business_user_email" },
            { title: "Storage Location", dataIndex: "inv_sloc_name", key: "inv_sloc_name" },
        ];

        return (
            <div className={styles.tableWrap} style={{ margin: "50px 0" }}>
                <Table
                    size="small"
                    tableLayout="auto"
                    rowKey={(row, index) => row.inv_stock_trx_id || index}
                    columns={columns}
                    dataSource={transactions}
                    pagination={false}
                    scroll={{ x: 1600 }}
                />
            </div>
        );
    };

    handlePrint = () => {
        window.print();
    };

    render() {
        const { loading, transactions, reportDateFrom, reportDateTo } = this.state;

        return (
            <Spin spinning={loading}>
                <Row>
                    <Col>
                        <div style={{ padding: 10 }}>
                            <div className="hideOnPrint printButtonFloating">
                                <Button type="primary" onClick={this.handlePrint}>Print</Button>
                            </div>
                            <h1>Transaksi Inventory</h1>
                            <table>
                                <tbody>
                                <tr>
                                    <td>Outlet</td>
                                    <td style={{ width: 15, textAlign: "center" }}>:</td>
                                    <td>{this.props.posConfig.brand_name} - {this.props.posConfig.outlet_name}</td>
                                </tr>
                                <tr>
                                    <td>Kasir</td>
                                    <td style={{ width: 15, textAlign: "center" }}>:</td>
                                    <td>{this.props.posConfig.cashier_name}</td>
                                </tr>
                                <tr>
                                    <td>Tanggal Laporan</td>
                                    <td style={{ width: 15, textAlign: "center" }}>:</td>
                                    <td>{moment(reportDateFrom, MOMENT_SQL_DATE_FORMAT).format(MOMENT_READABLE_DATE_FORMAT)} - {moment(reportDateTo, MOMENT_SQL_DATE_FORMAT).format(MOMENT_READABLE_DATE_FORMAT)}</td>
                                </tr>
                                <tr>
                                    <td>Waktu Pembuatan Laporan</td>
                                    <td style={{ width: 15, textAlign: "center" }}>:</td>
                                    <td>{moment().format(MOMENT_READABLE_DATETIME_FORMAT)}</td>
                                </tr>
                                </tbody>
                            </table>

                            {empty(transactions) && <Empty style={{ maxWidth: 500, margin: "100px 0" }} />}
                            {!empty(transactions) && this.renderTransactionTable(transactions)}
                        </div>
                    </Col>
                </Row>
            </Spin>
        );
    }
}

const mapStateToProps = state => {
    return {
        posConfig: state.authState.userData
    };
};

export default connect(mapStateToProps)(ReportProductConsumptionPrint);
